const SVG = (props: any) => {
  const width = props.width || '22'
  const height = props.height || '22'
  const color = props.color || '#7487AA'
  return (
    <svg
      width={width}
      height={height}
      style={props.style}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.75"
        y="2.75"
        width="6.5"
        height="6.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M15.8764 4.54492C15.0744 4.54492 14.4219 5.19743 14.4219 5.99947C14.4219 6.8015 15.0744 7.45401 15.8764 7.45401C16.6785 7.45401 17.331 6.8015 17.331 5.99947C17.331 5.19743 16.6785 4.54492 15.8764 4.54492ZM15.8764 6.72674C15.4754 6.72674 15.1491 6.40049 15.1491 5.99947C15.1491 5.59845 15.4754 5.27219 15.8764 5.27219C16.2774 5.27219 16.6037 5.59845 16.6037 5.99947C16.6037 6.40049 16.2774 6.72674 15.8764 6.72674Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
      <path
        d="M19.6289 6.9152L18.7802 6.16933C18.7834 6.11282 18.7851 6.05627 18.7851 6C18.7851 5.94371 18.7834 5.88715 18.7802 5.83064L19.6288 5.0848C19.759 4.97038 19.7904 4.77995 19.7037 4.62984L18.9764 3.37016C18.8898 3.22005 18.7091 3.15195 18.545 3.20752L17.4749 3.56955C17.3803 3.5072 17.2822 3.45047 17.1813 3.39971L16.9598 2.29232C16.9259 2.12235 16.7766 2 16.6033 2L15.1487 2C14.9754 2 14.8261 2.12235 14.7922 2.29232L14.5707 3.39971C14.4698 3.45047 14.3717 3.50722 14.2771 3.56955L13.207 3.20752C13.0428 3.152 12.8622 3.22005 12.7755 3.37016L12.0482 4.62984C11.9616 4.77995 11.9929 4.97038 12.1231 5.0848L12.9718 5.83064C12.9685 5.88708 12.9669 5.94364 12.9669 6C12.9669 6.05636 12.9685 6.11295 12.9718 6.16936L12.1231 6.9152C11.9929 7.02962 11.9616 7.22005 12.0483 7.37016L12.7755 8.62982C12.8622 8.77993 13.0428 8.848 13.207 8.79246L14.2771 8.43042C14.3717 8.49278 14.4698 8.5495 14.5707 8.60027L14.7922 9.70766C14.8261 9.87765 14.9754 10 15.1487 10H16.6033C16.7766 10 16.9259 9.87765 16.9598 9.70768L17.1813 8.60029C17.2822 8.54953 17.3803 8.49278 17.4748 8.43045L18.545 8.79248C18.7092 8.84798 18.8898 8.77998 18.9764 8.62984L19.7037 7.37016C19.7904 7.22005 19.7591 7.02962 19.6289 6.9152ZM18.4957 8.00802L17.5326 7.68221C17.4182 7.64352 17.292 7.66415 17.1959 7.73726C17.049 7.84902 16.889 7.94162 16.7202 8.01251C16.609 8.05925 16.5281 8.15811 16.5044 8.27646L16.3052 9.27273H15.4468L15.2476 8.27646C15.2239 8.15813 15.1431 8.05925 15.0318 8.01251C14.863 7.94158 14.7029 7.84899 14.5562 7.73728C14.4601 7.66412 14.3339 7.64347 14.2194 7.68218L13.2563 8.008L12.8271 7.26468L13.5906 6.59372C13.6812 6.51413 13.7264 6.39481 13.7114 6.2752C13.7 6.18456 13.6942 6.09198 13.6942 6C13.6942 5.90802 13.7 5.81544 13.7114 5.7248C13.7264 5.60516 13.6812 5.48587 13.5906 5.40625L12.8271 4.7353L13.2563 3.99195L14.2194 4.31777C14.3339 4.35646 14.46 4.33583 14.5562 4.26272C14.703 4.15098 14.863 4.05838 15.0318 3.98747C15.1431 3.94073 15.2239 3.84187 15.2476 3.72352L15.4468 2.72727H16.3052L16.5044 3.72354C16.5281 3.84187 16.6089 3.94075 16.7202 3.98749C16.889 4.0584 17.049 4.15101 17.1958 4.26274C17.292 4.33588 17.4181 4.35653 17.5326 4.31782L18.4956 3.99202L18.9248 4.73535L18.1614 5.4063C18.0708 5.48587 18.0256 5.60509 18.0406 5.72465C18.052 5.81576 18.0578 5.90841 18.0578 6.00002C18.0578 6.09164 18.052 6.18429 18.0406 6.27539C18.0256 6.39498 18.0709 6.51421 18.1614 6.59377L18.9249 7.26473L18.4957 8.00802Z"
        fill={color}
        stroke={color}
        strokeWidth="0.25"
      />
      <rect
        x="12.75"
        y="12.75"
        width="6.5"
        height="6.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="2.75"
        y="12.75"
        width="6.5"
        height="6.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default SVG
